import React, { Suspense } from "react";
import Layout from "./components/Layout/";
import {
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";

// Import Css
import "./Apps.css";

// Include Routes
import routes from "./routes/allRoutes";

const Loader = () => (
  <div id="preloader">
    <div id="status">
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  </div>
);

const withLayout = (WrappedComponent, hasDarkTopBar) => {
  const ComponentWithLayout = (props) => (
    <Layout hasDarkTopBar={hasDarkTopBar}>
      <WrappedComponent {...props} />
    </Layout>
  );
  ComponentWithLayout.displayName = `withLayout(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return ComponentWithLayout;
};

const App = () => {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Switch>
          {routes.map((route, idx) =>
            route.isWithoutLayout ? (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ) : (
              <Route
                key={idx}
                path={route.path}
                exact
                component={withLayout(route.component, route.isTopbarDark)}
              />
            )
          )}
        </Switch>
      </Suspense>
    </Router>
  );
};

export default App;
